var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cf-c-step-bar"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,class:[
                'cf-c-step-bar__item',
                { 'cf-is-active': _vm.activeStep === index }
            ]},[_vm._m(0,true)])}),0),_c('div',{staticClass:"cf-u-text-center cf-u-mb-md cf-u-mt-sm"},[_c('strong',[_vm._v(_vm._s(`${_vm.$t('REGULATION.STEP')} ${_vm.activeStep + 1}: ${_vm.$t( _vm.steps[_vm.activeStep].label )}`)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-step-bar__progress"},[_c('div',{staticClass:"cf-c-step-bar__line"}),_c('div',{staticClass:"cf-c-step-bar__dot"})])
}]

export { render, staticRenderFns }